<template>
  <div>
    <div class="nav-menu">
      <i class="fas fa-bars menu" @click="showMenu()"> </i>
      <div class="content">
        <div
          :class="showMobileMenu ? 'open-menu' : 'closed-menu'"
          class="nav-content"
        >
          <div
            v-if="!isMobileSize"
            class="desktop-logo"
            @click="goHomePage"
          >
            <img :src="scIcon" />
          </div>
          <ul class="nav-items">
            <li
              :class="{ shadow: addShadowHome }"
              class="detail"
              @click="goHomePage"
            >
              Home
            </li>
            <li
              :class="{ shadow: addShadowRoomType }"
              class="detail"
              @click="goRoomType"
            >
              Room type
            </li>
            <li
              :class="{ shadow: addShadowContactUs }"
              class="detail"
              @click="goContactUs"
            >
              Contact us
            </li>
          </ul>
          <div class="login-button">
            <a
              :class="!isMobileSize ? 'register' : ''"
              class="log-in"
              @click="handleBookingCustomerSearchClick"
              >จัดการบุ๊คกิ้ง</a
            >
          </div>
        </div>
      </div>
      <div v-if="isMobileSize" class="mobile-logo" @click="goHomePage">
        <img :src="scIcon" class="logo-image" />
      </div>
    </div>
  </div>
</template>

<script>
import { mlSize } from "./VariableStatic";

export default {
  data() {
    return {
      showMobileMenu: false,
      windowWidth: window.innerWidth,
      addShadowHome: false,
      addShadowRoomType: false,
      addShadowContactUs: false,
    };
  },
  computed: {
    isMobileSize() {
      return this.windowWidth <= mlSize;
    },
    scIcon() {
      return "/static/pictures/conference-header.svg";
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    showMenu() {
      this.showMobileMenu = !this.showMobileMenu;
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    goHomePage() {
      this.addShadowHome = true;
      setTimeout(() => {
        this.addShadowHome = false;
      }, 1500);

      this.$router.push({
        name: "DashboardConference",
      });
    },
    goRoomType() {},
    goContactUs() {},
    handleBookingCustomerSearchClick() {
      if (this.$route.path !== '/conference/search/customer') {
        this.$router.push({
          name: "ConferenceSearchCustomerBooking",
        });
      } else {
        window.location.reload();
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../css/otherWebVariables";

.nav-menu {
  background-color: white;
  z-index: 99999;
  height: 70px;
}
.nav-content {
  display: flex;
  justify-content: space-between;
  padding: 10px 30px;
  align-items: center;
}
.nav-items {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  list-style: none;
  margin-bottom: 0;
  margin-left: -180px;
  padding: 0;
}

i {
  display: none;
}

.register {
  box-sizing: border-box;
  /* flex-direction: row; */
  align-items: flex-start;
  padding: 10px 20px;
  /* width: 80px; */

  background: rgba(187, 97, 37, 0.1);
  border: 1px solid rgba(187, 97, 37, 0.2);
  border-radius: 4px;
  color: $color-orange;
}

.mobile-logo,
.desktop-logo,
.detail {
  cursor: pointer;
  font-weight: bold;
  padding-left: 10px;
  padding-right: 10px;
}

.shadow {
  box-shadow: 0 4px 16px 0 rgba(215, 215, 215, 0.7);
  transition: box-shadow 1s ease-in-out;
  border-radius: 15px;
}

@media screen and (max-width: $ml-size) {
  .nav-menu {
    padding-top: 10px;
    position: relative;
    width: 100%;
  }
  .open-menu {
    opacity: 1;
    height: 100%;
    background-color: $white;
    padding: 5px;
    border: 1px $color-background;
    box-shadow: 0 10px 10px 10px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
  .closed-menu {
    opacity: 0;
    height: 0;
    padding: 0;
  }
  .nav-content {
    flex-direction: column;
    z-index: 100;
    position: relative;
    transition: all 0.2s ease-out;
    width: 50%;
  }
  .nav-items {
    flex-direction: column;
    /* text-align: left; */
    width: 100%;
    margin: 0;
  }

  i {
    display: block;
    text-align: right;
    padding: 0 10px 10px 0;
  }

  .menu {
    font-size: 38px;
    color: $color-orange;
    text-align: left;
    padding-left: 20px;
    padding-top: 5px;
    z-index: 1;
  }

  .mobile-logo {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding-top: 7px;
    margin: auto;
    z-index: 0;
    width: 50%;
  }

  .content {
    padding-left: 10px;
  }

  .detail {
    border-bottom: 1px solid $color-background;
    width: 80%;
    margin-top: 5px;
    margin-bottom: 5px;
    padding-bottom: 10px;
  }

  .login-button {
    width: 100%;
    /* padding-top: 20px;
    padding-bottom: 10px; */
  }

  .log-in {
    cursor: pointer;

    &:hover {
      text-decoration: none;
      color: black;
  
      background: #efefef;
    }
  }

  .logo-image {
    padding-top: 8px;
  }
}

@media screen and (max-width: $m-size - 1) {
  .logo-image {
    padding-top: 8px;
    width: 90%;
  }
}
</style>